import SEO from "@/components/SEO";
import ContactDetails from "@/components/ContactDetails";
import EnquiryForm from "@/components/EnquiryForm";

export default function Contact() {
  return (
    <>
      <SEO
        title="Contact | Yaduraj Enterprises"
        description="Tell us about your solar, BESS or electrical project. Offices in Barmer (Rajasthan) and New Delhi. We respond within 48 hours."
      />
      <section className="ye-page-hero">
        <div className="ye-container">
          <span className="ye-eyebrow">Contact</span>
          <h1 className="ye-display ye-h1" style={{ margin: "8px 0 18px" }}>Tell Us About Your Project</h1>
          <p style={{ maxWidth: 880, fontSize: 17, color: "rgba(255,255,255,0.9)" }}>
            Share your scope and location — we&apos;ll come back with a mobilisation-ready response within 48 hours.
          </p>
        </div>
      </section>

      <section className="ye-section">
        <div className="ye-container ye-grid-2" style={{ gap: 44, alignItems: "start" }}>
          <ContactDetails />
          <EnquiryForm />
        </div>
      </section>
    </>
  );
}
